import { useEffect } from 'react';
import { useAddKalturaScript } from './useAddKalturaScript.js';

function Kaltura(props) {
  const { videoId, targetId, seekToPositionKalturaReady } = props;
  const targetDiv = targetId || `kaltura_player_${videoId}`;

  const {
    hasError: {
      errorDetected, errorMessage,
    }, seekToPositionKaltura,
  } = useAddKalturaScript({
    ...props,
    targetDiv,
  });
  // seekToPositionKalturaReady modifies the state of its parent component, so we need a
  // useEffect here
  useEffect(() => {
    if (seekToPositionKalturaReady) {
      seekToPositionKalturaReady(seekToPositionKaltura);
    }
  }, [seekToPositionKaltura, seekToPositionKalturaReady]);

  // if there is an error loading the script, throw an error, which will be caught by an ErrorBoundary
  if (errorDetected) {
    throw new Error(errorMessage);
  }

  return (
    <div className="lds-player-wrapper with-interstitial">
      <div id={targetDiv} className="kaltura_player"></div>
    </div>
  );
}

export default Kaltura;
